<script setup>
import { ref } from 'vue'
import { DxSelectBox } from 'devextreme-vue'

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  items: {
    type: Array,
    default: () => [],
  },
  disabled: { type: Boolean, default: false },
})

const emit = defineEmits({
  valueChanged: (e) => true,
})

const initialValue = () => {
  const row = props.data?.data
  if (row?.processing_parent_id != null) return `present:${row.processing_parent_id}`
  if (row?.parent_id != null && row?.parent_id !== 0) return `present:${row.parent_id}`
  if (row?.id != null && row?.intervention_type_ref != null) return `present:${row.id}`
  return props.data?.value != null ? `new:${props.data.value}` : null
}

const currentValue = ref(initialValue())

const onValueChanged = (e) => {
  const selectedValue = e?.value ?? null
  const selectedItem = props.items.flatMap(group => group.items ?? []).find(item => item.value === selectedValue)
  currentValue.value = selectedValue
  props.data?.setValue(selectedItem?.interventionTypeRef ?? null)
  emit('valueChanged', {
    value: selectedItem?.interventionTypeRef ?? null,
    parentId: selectedItem?.parentId ?? null,
    event: e,
  })
}
</script>

<template>
  <dx-select-box
    :value="currentValue"
    :items="props.items"
    :grouped="true"
    :disabled="props.disabled"
    display-expr="name"
    value-expr="value"
    group-template="group"
    @value-changed="onValueChanged"
  >
    <template #group="{ data: groupInfo }">
      <div
        v-if="groupInfo.items?.length > 0"
        class="full-width"
      >
        <div
          class="text-overline text-weight-bold text-grey-8 q-px-md q-pb-xs"
          style="border-bottom: 1px solid var(--q-separator-color, #dfe3e8);"
        >
          {{ groupInfo.key }}
        </div>
      </div>
    </template>
  </dx-select-box>
</template>
